import NewResponsiveImage from "@components/CustomTypography/NewResponsiveImage/NewResponsiveImage"
import Typography, {
	Size,
	Variant,
} from "@components/WebsiteRevamp/Typography/Typography"
import {
	CategoryModuleType,
	CustomerStoryModuleType,
} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import Link from "next/link"
import React from "react"

import CardsCategoryButton from "../CardsCategoryButton/CardsCategoryButton"

import styles from "./CustomerStoryVertical.module.scss"

type Props = {
	data: CustomerStoryModuleType
	className?: string
	minimal?: boolean
	onWhiteBackground?: boolean
}

const CustomerStoryVertical = (props: Props) => {
	const preview = props.data.preview.filename
		? props.data.preview
		: props.data.logo

	const stylesCustom = props.onWhiteBackground
		? {backgroundColor: "#F8FAFE"}
		: {}

	return (
		<Link
			className={`${styles.cardContainer} ${props.className}`}
			data-testid={"customerStoryVerticalContainer"}
			href={props.data.link}
			rel={"noreferrer"}
			style={{...stylesCustom}}
		>
			<NewResponsiveImage
				{...preview}
				containerClassName={styles.imageContainer}
				imageClassName={styles.image}
				alt={props.data.title ?? preview?.alt}
			/>

			<div className={styles.contentContainer}>
				<div className={styles.upperTitle}>
					<Typography
						className={styles.links}
						content={
							<>
								{props.data.useCase.map(
									(
										element: CategoryModuleType,
										index: number,
									) => {
										return (
											<CardsCategoryButton
												key={index}
												data={element}
												link={"customerStories"}
												modifier={"useCases"}
											/>
										)
									},
								)}
								<CardsCategoryButton
									data={props.data.industry?.[0]}
									link={"customerStories"}
									modifier={"industries"}
								/>
							</>
						}
						fontWeight={600}
						size={Size.XS}
					/>
				</div>
				<Typography
					content={props.data.title}
					size={Size.XS}
					variant={Variant.Title}
					noPadding
				/>
			</div>
		</Link>
	)
}

export default CustomerStoryVertical
